import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import auth from './modules/auth';
import apps from './modules/apps';

const vuexPersistence = new VuexPersistence({
  storage: localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loggedUser: {},
    isLoggedIn: false,
    status: '',
    /* User */
    userName: null,
    userEmail: null,
    userAvatar: null,

    /* NavBar */
    isNavBarVisible: true,

    /* FooterBar */
    isFooterBarVisible: true,

    /* Aside */
    isAsideVisible: true,
    isAsideMobileExpanded: false
  },
  getters: {
    getLoggedUser: state => state.loggedUser,
    getStatus: state => state.status,
    isLoggedIn: state => state.isLoggedIn
  },
  mutations: {
    /* A fit-them-all commit */
    basic(state, payload) {
      state[payload.key] = payload.value;
    },
    loginSuccess: (state, data) => {
      state.loggedUser = data;
      state.isLoggedIn = true;
    },

    setLoggedUser: (state, user) => {
      state.loggedUser = user;
    },

    logout: state => {
      localStorage.removeItem('vuex');
      state.loggedUser = {};
      state.status = 'success';
      state.isLoggedIn = false;
    },

    /* User */
    user(state, payload) {
      if (payload.name) {
        state.userName = payload.name;
      }
      if (payload.email) {
        state.userEmail = payload.email;
      }
      if (payload.avatar) {
        state.userAvatar = payload.avatar;
      }
    },

    /* Aside Mobile */
    asideMobileStateToggle(state, payload = null) {
      const htmlClassName = 'has-aside-mobile-expanded';

      let isShow;

      if (payload !== null) {
        isShow = payload;
      } else {
        isShow = !state.isAsideMobileExpanded;
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName);
      } else {
        document.documentElement.classList.remove(htmlClassName);
      }

      state.isAsideMobileExpanded = isShow;
    },
    reqInit: state => {
      state.status = 'loading';
    },
    reqSuccess: state => {
      state.status = 'success';
    },
    reqError: state => {
      state.status = 'error';
    }
  },
  actions: {
    logoutUser: ({ commit }) => {
      commit('logout');
    }
  },
  modules: {
    auth,
    apps
  },
  plugins: [vuexPersistence.plugin]
});
